import React, { useContext } from 'react';
import styles from './AdviseChanges.styles.js';
import { AppContext } from 'App.context.js';

export default function AdviceChanges({ applyToAllHotels, updateSenderRecipients }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const list1 = translate('mailTemplates.adviceChangesList1').split('\n');
  const list2 = translate('mailTemplates.adviceChangesList2').split('\n');

  let itemList = '';
  if (updateSenderRecipients) {
    itemList = list1.map(item => {
      return <div style={styles.desc}>{item}</div>;
    });
  } else {
    itemList = list2.map(item => {
      return <div style={styles.desc}>{item}</div>;
    });
  }

  return (
    <div>
      <div style={styles.desc}>{translate('mailTemplates.adviceChanges')}</div>
      {itemList}
      {applyToAllHotels ? (
        <div style={styles.desc}>
          <b>{translate('mailTemplates.adviceChangesAll')}</b>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
